// See https://docs.google.com/document/d/1c22TCUZTVS3A8JOcfYMQieGv87DSq9wxYSPRdGw9F08 for more details
// on nav tracking fields.
export function getCategory(element) {
    return getClosestDataAttribute(element, 'data-category');
}
export function getDynamicVariation(element) {
    return getClosestDataAttribute(element, 'data-dynamic-variation');
}
export function getSubcategory(element) {
    return getClosestDataAttribute(element, 'data-subcategory');
}
export function getLocation(element) {
    return getClosestDataAttribute(element, 'data-component-type');
}
export function getNavDeviceType(element) {
    return getClosestDataAttribute(element, 'data-nav-device-type');
}
export function isNavSticky(element) {
    return element.closest('.isSticky') ? true : false;
}
function getClosestDataAttribute(element, dataAttribute) {
    if (!element) {
        return undefined;
    }
    return element.closest(`[${dataAttribute}]`)
        ? element.closest(`[${dataAttribute}]`).getAttribute(dataAttribute)
        : undefined;
}
